import { useQuery } from '@tanstack/react-query'
import { listOrganizations } from '../api/catalogues.js'

// A simple native <select> populated from /catalogues/organizations?org_type=…
// Kept dead simple on purpose — native controls cost nothing in bandwidth or
// JS and are the most reliable on low-end Android browsers.
export default function OrgSelect({ orgType, value, onChange, disabled, placeholder = 'Select…' }) {
  const { data = [], isLoading } = useQuery({
    queryKey: ['orgs', orgType],
    queryFn: () => listOrganizations(orgType),
    staleTime: 10 * 60_000,
  })
  return (
    <select
      className="w-full border rounded px-2 py-2 text-sm bg-white disabled:bg-slate-100"
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled || isLoading}
    >
      <option value="">{isLoading ? 'Loading…' : placeholder}</option>
      {data.map((o) => (
        <option key={o.id} value={o.id}>{o.name}</option>
      ))}
    </select>
  )
}
